export const getAssociatedAgreements = (state) => {
  const associatedAgreements = state.associatedAgreements.associatedAgreements;
  const keyList = Object.keys(associatedAgreements);
  const agreementList = [];
  keyList.forEach((key) => {
    agreementList.push(...associatedAgreements[key].associatedAgreements);
  });
  return agreementList;
};

export const getAssociatedAgreementsBuyBank = (state) => {
  const associatedAgreements = state.associatedAgreements.associatedAgreements;
  return associatedAgreements;
};
export const getPendingStatusAgreements = (state) => {
  const associableAgreements = state.associatedAgreements.associatedAgreements;
  const keyList = Object.keys(associableAgreements);
  const pendingAgreements = [];
  keyList.forEach((key) => {
    pendingAgreements.push(
      ...(associableAgreements[key]?.pendingStatusAgreements || [])
    );
  });
  return pendingAgreements;
};

export const getAssociableAgreements = (state) => {
  const associableAgreements = state.associatedAgreements.associatedAgreements;
  const keyList = Object.keys(associableAgreements);
  const agreementList = [];
  keyList.forEach((key) => {
    agreementList.push(...associableAgreements[key].associableAgreements);
  });
  return agreementList;
};
